import { ReactElement } from "react";
import { isFirstLetterUpperCase, removeHTMLfromString } from "./text-helper";

export const getSearchHitTextFromFullText = (
  fullText: Array<string>,
  searchQuery: string
): ReactElement | undefined => {
  const BEFORE_CHARACTERS = 70;
  const AFTER_CHARACTERS = 20;

  const itemsWithSearchQuery = fullText.filter((text) => text.toLowerCase().includes(searchQuery.toLowerCase()));
  const cleanItems = itemsWithSearchQuery.map((item) => removeHTMLfromString(item));
  const firstItem = cleanItems[0];

  if (!firstItem) {
    const cleanItemsWithoutSearchQuery = fullText.map((item) => removeHTMLfromString(item));
    const firstItem = cleanItemsWithoutSearchQuery[0];

    if (!firstItem[0]) {
      return undefined;
    }

    const text = firstItem.substring(0, BEFORE_CHARACTERS);
    const shouldAddEllipsis = text.length < firstItem.length;

    return (
      <p>
        {text}
        {shouldAddEllipsis ? "..." : ""}
      </p>
    );
  }

  const index = firstItem.toLowerCase().indexOf(searchQuery.toLowerCase());
  const textBefore = firstItem.substring(index - BEFORE_CHARACTERS, index);
  const textAfter = firstItem.substring(index + searchQuery.length, index + searchQuery.length + AFTER_CHARACTERS);

  const shouldAddEllipsisBefore = !isFirstLetterUpperCase(textBefore) && textBefore.length > 0;
  const shouldAddEllipsisAfter = textAfter.length > 0;

  return (
    <p>
      {shouldAddEllipsisBefore ? "..." : ""}
      {textBefore}
      <span className="search-hit">{searchQuery}</span>
      {textAfter}
      {shouldAddEllipsisAfter ? "..." : ""}
    </p>
  );
};

export const shouldShowSearchLoader = (
  isLoadingPostSearchTerm: boolean,
  searchTerm: string,
  debouncedSearchTerm: string
) => {
  if (searchTerm === "") {
    return false;
  }

  if (searchTerm !== debouncedSearchTerm) {
    return true;
  }

  return isLoadingPostSearchTerm;
};
